export default __webpack_public_path__ + "static/media/noexpl_013_DE.c26d7c2e.png";